'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './abstract-video-player.component';
import dynamic from 'next/dynamic';

const DynamicAbstractVideoPlayerComponent: ComponentType<Props> = dynamic(
  () => import('./abstract-video-player.component')
);

export default DynamicAbstractVideoPlayerComponent;

export function calculateAbstractVideoPlayerPlaceholderConfig(props: Props): PlaceholderConfig {
  const contentHtmlHeight: number = props.height;

  const heightSinceWidth = [
    { sinceWidth: 0, height: contentHtmlHeight / 2 + 48 },
    { sinceWidth: 768, height: contentHtmlHeight / 2 + 48 },
    { sinceWidth: 1024, height: contentHtmlHeight / 2 + 48 },
    { sinceWidth: 1440, height: contentHtmlHeight / 2 + 48 }
  ];

  return {
    heightSinceWidth
  };
}
